import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FileUploaderPreview from './components/FileUploaderPreview/FileUploaderPreview';
import FileUploaderButton from './components/FileUploaderButton/FileUploaderButton';
import { Icon, getFilePicker } from 'components';
import styles from './FileUploader.scss';

const FileUploader = ({
    buttonEmptyText,
    buttonText,
    defaultValue,
    fileStackConfig,
    onChange,
    isDisabled
}) => {
    const [file, setFile] = useState(defaultValue);
    const { filename } = file;
    const handleFielUpload = (file) => {
        setFile(file);
        onChange(file);
    };

    const picker = getFilePicker(fileStackConfig, handleFielUpload);

    return (
        <React.Fragment>
            {
                filename &&
                    <div className={styles.previewHolder}>
                        <FileUploaderPreview
                            file={file}
                            policy={fileStackConfig.fileStackPolicy}
                            signature={fileStackConfig.fileStackSignature}
                        />
                    </div>
            }
            <FileUploaderButton
                onUploadFile={() => picker.open()}
                text={filename ? buttonText : buttonEmptyText}
                disabled={isDisabled}
            />

            <div className={styles.fileName}>
                {
                    filename &&
                        <React.Fragment>
                            <Icon name='ion-md-copy' />{ filename }
                        </React.Fragment>
                }
            </div>
        </React.Fragment>
    );
};

FileUploader.propTypes = {
    buttonEmptyText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    defaultValue: PropTypes.shape({
        file: PropTypes.object
    }).isRequired,
    isDisabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    fileStackConfig: PropTypes.shape({
        location: PropTypes.string,
        container: PropTypes.string,
        region: PropTypes.string,
        fileStackSources: PropTypes.arrayOf(PropTypes.string),
        fileStackAccept: PropTypes.arrayOf(PropTypes.string),
        fileStackPolicy: PropTypes.string,
        fileStackSignature: PropTypes.string,
        fileStackApiKey: PropTypes.string,
        fileStackCname: PropTypes.string
    }).isRequired
};

export default FileUploader;
